import React from 'react';
import { useState, useEffect } from 'react';
import styles from '../../styles/Navbar.module.scss';
import perx from '../../assets/images/Perx-logo.png';
import profile from '../../assets/images/profile.png';
import { Hamburger } from '../../assets/icons';
import { Link, useNavigate } from 'react-router-dom';
import useLocalStorage from "../../hooks/useLocalStorage";
import Cookies from "js-cookie";

const Navbar = ({ setMobileNav, mobileNav }) => {
  const navigate = useNavigate()
  const { getLocalStorage } = useLocalStorage();
  const userData = getLocalStorage("user");
  const [navText, setNavText] = useState('Dashboard');
  const [navPText, setNavPText] = useState(
    'View all statistics on the dashboard',
  );
  const currentURL = window.location.href;

  useEffect(() => {
    const linkValue = currentURL.split('/')?.length - 1;
    const currentPage = currentURL.split('/')[linkValue];
    const parentPage = currentURL.split('/')[linkValue - 1];



    if (currentPage === '') {
      setNavText('Dashboard');
      setNavPText('View all statistics on the dashboard');
    } else if (currentPage === 'customer-audit-log') {
      setNavText('Customer Audit Log');
      setNavPText('View customer audit log');
    } else if (currentPage === 'handle-member-query' || parentPage === 'handle-member-query') {
      setNavText('Handle Member Query');
      setNavPText('View all report here');
    } else if (currentPage === 'points-management') {
      setNavText('Points Management');
      setNavPText('Manage customers redemption here');
    } else if (parentPage === 'points-award' && currentPage === 'transactions') {
      setNavText('Points Award');
      setNavPText('Manage customers redemption here');
    } else if (parentPage === 'points-award' && currentPage === 'audit-log') {
      setNavText('Points Award Audit Log');
      setNavPText('View points award audit log');
    } else if (parentPage === 'points-award' && currentPage === 'reports') {
      setNavText('Points Award Reports');
      setNavPText('View points award reports');
    } else if (currentPage === 'admin-audit-log') {
      setNavText('Admin Audit Log');
      setNavPText('View admin audit logs');
    } else if (currentPage === 'reset-enrolment') {
      setNavText('Reset Enrolment');
      setNavPText('');
    } else if (currentPage === 'transaction-channel') {
      setNavText('Transaction Channel');
      setNavPText('');
    } else if (currentPage === "points-approvals" || parentPage === "points-approvals") {
      setNavText("Points Approvals");
      setNavPText("Review and approve pending customer point adjustments");
    } else if (parentPage === "points-award" && currentPage === "transactions") {
    } else {
      setNavText('Report');
      setNavPText('View all report here');
    }
  }, [currentURL]);

  const [isResponsive, setIsResponsive] = useState(false);
  const toggleResponsiveClass = () => {
    setMobileNav(!mobileNav);
  };

  // handle logout
  const handleLogoutFn = () => {
    localStorage.clear()
    Cookies.remove("token")
    navigate("/")

  }

  return (
    <div className={styles.topnav}>
      <div className={styles.navContainer}>
        <div className={styles.navTextContainer}>
          <h4 className={styles.navText1}>{navText}</h4>
          <p className={styles.navText2}>{navPText}</p>
        </div>

        <div className={styles.profileContainer}>
          <div className={styles.profile}>
            <div className={styles.profilePicture}>
              <img src={profile} alt="profile" />
            </div>
            <p className={styles.profileName}>{`Hello, ${userData?.First_name}`}</p>
          </div>
          {/* <Link to="https://greenrewardsdemo.perxclm.com/PerXCLM.php"> */}
          <button className={styles.perxButton} onClick={handleLogoutFn}>
            Log out
          </button>
          {/* </Link> */}

          <div className={styles.Hamburger} onClick={toggleResponsiveClass}>
            <Hamburger />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
